import { FormControl, OutlinedInput, InputAdornment, Grid } from "@mui/material";
import { useState, useEffect, useCallback } from "react";

const DebtAmount = ({ page, setPage, formData, setFormData }) => {
    const [rentAmountError, setRentAmountError] = useState(null);
    const [creditAmountError, setCreditAmountError] = useState(null);
    const [otherAmountError, setOtherAmountError] = useState(null);

    const preventNonPositiveInteger = (e) => {
        if (e.key === "e" || e.key === "." || e.code === 'Minus' || e.code === 'ArrowUp' || e.code === 'ArrowDown') {
            e.preventDefault();
        }
    };

    const onRentAmountChange = (e) => {
        if (e.target.value.length > 8) {
            e.preventDefault();
        } else {
            setFormData({ ...formData, rentMortgagePayment: parseInt(e.target.value, 10) });
        }
        setRentAmountError(null);
    }
    const onCreditAmountChange = (e) => {
        if (e.target.value.length > 8) {
            e.preventDefault();
        } else {
            setFormData({ ...formData, ccDebtAmount: parseInt(e.target.value, 10) });
        }
        setCreditAmountError(null);
    }
    const onOtherAmountChange = (e) => {
        if (e.target.value.length > 8) {
            e.preventDefault();
        } else {
            setFormData({ ...formData, unsecuredDebtAmount: parseInt(e.target.value, 10) });
        }
        setOtherAmountError(null);
    }

    const preventPaste = (e) => {
        e.preventDefault();
    };

    const updateFormData = useCallback(() => {
        setFormData(formData);
    }, [formData, setFormData]);

    useEffect(() => {
        updateFormData();
    }, [updateFormData]);

    useEffect(() => {
        setRentAmountError(null);
        setCreditAmountError(null);
        setOtherAmountError(null);
    }, [formData.lang]);

    const validateData = () => {
        var valid = true;

        if (formData.rentMortgagePayment === "") {
            setRentAmountError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else if (formData.rentMortgagePayment >= 0) {
            setRentAmountError(null);
        } else {
            valid = false;
            setRentAmountError(formData.lang === "fr" ? "Veuillez saisir un nombre entier positif (pas de décimales ni de virgules)" : "Please enter a positive whole number (no decimals or commas)");
        }

        if (formData.ccDebtAmount === "") {
            setCreditAmountError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else if (formData.ccDebtAmount >= 0) {
            setCreditAmountError(null);
        } else {
            valid = false;
            setCreditAmountError(formData.lang === "fr" ? "Veuillez saisir un nombre entier positif (pas de décimales ni de virgules)" : "Please enter a positive whole number (no decimals or commas)");
        }

        if (formData.unsecuredDebtAmount === "") {
            setOtherAmountError(formData.lang === "fr" ? "Ceci est nécessaire" : "This field is required");
            valid = false;
        } else if (formData.unsecuredDebtAmount >= 0) {
            setOtherAmountError(null);
        } else {
            valid = false;
            setOtherAmountError(formData.lang === "fr" ? "Veuillez saisir un nombre entier positif (pas de décimales ni de virgules)" : "Please enter a positive whole number (no decimals or commas)");
        }

        if (valid) {
            window.dataLayer.push({'event': 'loan_step10', 'loanEvent': 'step10', 'loanEventID': 11});
            // quebec only
            // window.dataLayer.push({'event': 'loan_step10q', 'loanEvent': 'step10q', 'loanEventID': '11q'});
            setPage(page + 1);
        }
    }

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Paiement du loyer / hypothèque" : "Rent / Mortgage Payment"}</div>
                <FormControl fullWidth>
                    <OutlinedInput
                        type="number"
                        startAdornment={
                            <div className="custom-start-adornment-div">
                                <InputAdornment style={{ marginLeft: 10 }} position="start">$</InputAdornment>
                            </div>
                        }
                        endAdornment={
                            <div className="custom-end-adornment-div">
                                <InputAdornment style={{ marginRight: 10 }} position="end">.00</InputAdornment>
                            </div>
                        }
                        value={formData.rentMortgagePayment}
                        min="0"
                        onPaste={preventPaste}
                        onKeyDown={preventNonPositiveInteger}
                        onWheel={(e) => e.target.blur()}
                        onChange={onRentAmountChange}
                    />
                </FormControl>
                <div className="error-text">{rentAmountError}</div>
                <div className="textfield-label">{formData.lang === "fr" ? "Dette de carte de crédit" : "Credit Card Debt"}</div>
                <FormControl fullWidth>
                    <OutlinedInput
                        type="number"
                        startAdornment={
                            <div className="custom-start-adornment-div">
                                <InputAdornment style={{ marginLeft: 10 }} position="start">$</InputAdornment>
                            </div>
                        }
                        endAdornment={
                            <div className="custom-end-adornment-div">
                                <InputAdornment style={{ marginRight: 10 }} position="end">.00</InputAdornment>
                            </div>
                        }
                        value={formData.ccDebtAmount}
                        min="0"
                        onPaste={preventPaste}
                        onKeyDown={preventNonPositiveInteger}
                        onWheel={(e) => e.target.blur()}
                        onChange={onCreditAmountChange}
                    />
                </FormControl>
                <div className="error-text">{creditAmountError}</div>
                <div className="textfield-label">{formData.lang === "fr" ? "Total des autres dettes non garanties" : "Total of Other Unsecured Debt"}</div>
                <FormControl fullWidth>
                    <OutlinedInput
                        type="number"
                        startAdornment={
                            <div className="custom-start-adornment-div">
                                <InputAdornment style={{ marginLeft: 10 }} position="start">$</InputAdornment>
                            </div>
                        }
                        endAdornment={
                            <div className="custom-end-adornment-div">
                                <InputAdornment style={{ marginRight: 10 }} position="end">.00</InputAdornment>
                            </div>
                        }
                        value={formData.unsecuredDebtAmount}
                        min="0"
                        onPaste={preventPaste}
                        onKeyDown={preventNonPositiveInteger}
                        onWheel={(e) => e.target.blur()}
                        onChange={onOtherAmountChange}
                    />
                </FormControl>
                <div className="error-text">{otherAmountError}</div>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                validateData();
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default DebtAmount;